export default __webpack_public_path__ + "static/media/CafeAvion-1.0fb842e4.jpg";